import React, {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";
import {StampWrapper} from "./styles";
import stamp from "../../../../assets/images/reservation/instant-booking-stamp.svg";

const Stamp = () => {
    const {t} = useTranslation();
    const spanRef = useRef();
    const originalSizeRef = useRef(null);

    const text = t('INSTANT_BOOKING');

    useEffect(() => {
        const span = spanRef.current;
        if (!span) {
            return;
        }
        originalSizeRef.current = parseInt(
            window.getComputedStyle(span, null).getPropertyValue("font-size"),
            10
        );
    }, []);

    useEffect(() => {
        const span = spanRef.current;
        const originalSize = originalSizeRef.current;
        if(!span || !originalSize) return;
        span.style.fontSize = `${originalSize}px`;
        let currentSize = parseInt(
            window.getComputedStyle(span, null).getPropertyValue("font-size"),
            10
        );
        while (span.scrollHeight > span.clientHeight) {
            currentSize--;
            span.style.fontSize = `${currentSize}px`;
        }
    }, [text]);


    return <StampWrapper>
        <img src={stamp} alt="instant booking"/>
        <span ref={spanRef}>{text}</span>
    </StampWrapper>
}

export default Stamp;
